<!-- eslint-disable vue/no-bare-strings-in-template -->
<script setup>
import { ref, watch } from 'vue';
import Modal from 'dashboard/components/Modal.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { updateStageConfiguration } from 'dashboard/api/aceleres/funilConfiguration';

const props = defineProps({
  show: Boolean,
  accountId: { type: [String, Number], default: '' },
  stage: { type: Object, default: null },
});
const emit = defineEmits(['update:show', 'saved']);
const form = ref({
  description: '',
  entry_criteria: '',
  required_evidence_level: '',
  who_validates: '',
});
const saving = ref(false);
const error = ref('');
watch(
  () => props.stage,
  value => {
    form.value = {
      description: value?.description || '',
      entry_criteria: value?.entry_criteria || '',
      required_evidence_level: value?.required_evidence_level || '',
      who_validates: value?.who_validates || '',
    };
    error.value = '';
  },
  { immediate: true }
);
const save = async () => {
  if (!props.stage || saving.value) return;
  saving.value = true;
  error.value = '';
  try {
    await updateStageConfiguration(props.accountId, props.stage.id, form.value);
    emit('saved', { ...props.stage, ...form.value });
    emit('update:show', false);
  } catch (e) {
    error.value = e.message;
  } finally {
    saving.value = false;
  }
};
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <Modal
    :show="show"
    :on-close="() => emit('update:show', false)"
    @close="emit('update:show', false)"
  >
    <form class="flex flex-col gap-4 p-8" @submit.prevent="save">
      <h2 class="text-lg font-medium text-n-slate-12">Configurar etapa</h2>
      <p class="text-sm text-n-slate-11">{{ stage?.nome || 'Etapa' }}</p>
      <label
        >O que significa estar nesta etapa<textarea
          v-model="form.description"
          rows="3"
        />
      </label>
      <label
        >Critério de entrada<textarea v-model="form.entry_criteria" rows="3" />
      </label>
      <label
        >Nível mínimo de evidência<select
          v-model="form.required_evidence_level"
        >
          <option value="">Não definido</option>
          <option value="intencao">Intenção</option>
          <option value="tentativa">Tentativa</option>
          <option value="acao_concluida">Ação concluída</option>
        </select></label
      >
      <label
        >Quem precisa confirmar<select v-model="form.who_validates">
          <option value="">Não definido</option>
          <option value="vendedor">Vendedor</option>
          <option value="cliente">Cliente</option>
          <option value="ambos">Vendedor e cliente</option>
        </select></label
      >
      <span v-if="error" class="text-xs text-n-ruby-11">{{ error }}</span>
      <div class="flex justify-end gap-2">
        <NextButton
          type="button"
          faded
          slate
          label="Cancelar"
          @click="emit('update:show', false)"
        /><NextButton type="submit" label="Salvar" :is-loading="saving" />
      </div>
    </form>
  </Modal>
</template>
